<template>
  <VueApexCharts
    :height="props.height ? props.height : '300px'"
    :options="props.options"
    :series="series.length > 0 ? series : props.series"
  ></VueApexCharts>
</template>

<script>
import VueApexCharts from "vue-apexcharts";
export default {
  name: "Grafico",
  props: {
    props: {
      type: Object,
      default: () => {},
      required: true
    },
    series: {
      type: Array,
      default: () => []
    }
  },
  components: {
    VueApexCharts,
  },
};
</script>
